module.exports = __webpack_public_path__ + "static/media/roku.0fccb313.svg";